import { createPreprClient } from "@preprio/nodejs-sdk";

export const prepr = createPreprClient({
  token: "efdc465c4561ce1144e6f0126b2590a65f362b97815b4eb9f257a5aafe4c3246",
  baseUrl: "https://graphql.prepr.io/graphql",
});
